import config from "./config"

const currentRegion = config?.currentRegion
export const currentRegionMapping = {
    [currentRegion] : currentRegion,
    'EN' : 'ESAN',
    'ES' : 'LATAM',
}
  
  export const getCustomGroupRegion = (segment) => {
    if(config?.is_segmented && segment){
      return segment
    }
    return currentRegionMapping[currentRegion]
  }